export const RAG_STARTER_IMPORT_YAML = `project:
  name: rag-prod
  # enable when you have credits
  # corePackage: SERIOUS
  envVariables:
    # PostgreSQL connection
    DB_HOST: \${db_hostname}
    DB_PORT: \${db_port}
    DB_NAME: \${db_dbName}
    DB_USER: \${db_user}
    DB_PASSWORD: \${db_password}

    # Object Storage
    AWS_ACCESS_KEY_ID: \${storage_accessKeyId}
    AWS_REGION: us-east-1
    AWS_BUCKET: \${storage_bucketName}
    AWS_ENDPOINT: \${storage_apiUrl}
    AWS_SECRET_ACCESS_KEY: \${storage_secretAccessKey}
    AWS_URL: \${storage_apiUrl}/\${storage_bucketName}
    AWS_USE_PATH_STYLE_ENDPOINT: "true"

    # NATS
    NATS_URL: nats://\${queue_hostname}:\${queue_port}
    NATS_USER: \${queue_user}
    NATS_PASSWORD: \${queue_password}

    # Qdrant
    QDRANT_URL: \${qdrant_connectionString}
    QDRANT_API_KEY: \${qdrant_apiKey}

    # Valkey/Redis
    REDIS_HOST: \${cache_hostname}
    REDIS_PORT: "6379"

services:
  - hostname: db
    type: postgresql@16
    mode: HA
    priority: 100

  - hostname: cache
    type: valkey@7.2
    mode: HA
    priority: 100

  - hostname: queue
    type: nats@2.10
    mode: HA
    priority: 100

  - hostname: qdrant
    type: qdrant@1.12
    mode: HA
    priority: 100

  - hostname: storage
    type: object-storage
    objectStorageSize: 2
    objectStoragePolicy: public-read
    priority: 100

  - hostname: api
    type: python@3.11
    buildFromGit: https://github.com/zeropsio/recipe-rag-starter
    enableSubdomainAccess: true
    minContainers: 2
    envSecrets:
      WORKERS: "1"
    priority: 50

  - hostname: processor
    type: python@3.11
    buildFromGit: https://github.com/zeropsio/recipe-rag-starter
    minContainers: 2
    priority: 50

  - hostname: dashboard
    type: static
    buildFromGit: https://github.com/zeropsio/recipe-rag-starter
    enableSubdomainAccess: true`;
